export default __webpack_public_path__ + "static/media/goals.d8780910.png";